
    import { Vue, Component, Prop } from 'vue-property-decorator'

    @Component
    export default class MaintenanceNotice extends Vue {
        @Prop() message!: string
    }
